<div style="background-color: whitesmoke" >
    <div class="row center">
        <div class="col-xs-12 center">
            <br>
            <h2>Welcome to audEERING Event App Tutorial</h2>
            <br>
            Create your own personalized event questionnaire powered by AI.
        </div>
    </div>
    <br>
    <br>
    <br>
    </div>


    <hr>
    <div class="row center">
        <div class="col-xs-12">
            <h3>Easier than you can imagine </h3>
            <p> Learn how to create/edit events and questions </p>
        </div>

    </div>
    <br>



    <div class="row">
            <div class="col-md-7">
                    <img class="img-responsive img-thumbnail" [src]="EventDetail" alt="Event Detail">
            </div>
            <div class="col-md-5">
                <br>
                <hr>
                <h4>Creating an Event </h4>
                <p> You can easily create a new event by clicking on the "New Event" Button (Number 1)</p>
                <hr>
                    <h4>Edit/Delete Event </h4>
                <p> Clicking on the "Manage Event" (number 2) dropdown will bring up the options to delete or edit your event.</p>
                <hr>
                    <h4>Audience Code </h4>
                <p> This QR Code (number 3) should be used by audience, so that we can make sure they do not participate multiple times. </p>
                <hr>
                <h4>Event Administrators's Code </h4>
                <p> This QR Code (number 4) should be used by event administrators. They have the ability to fill in the questionnaire multiple times. </p>
                <hr>
                <h4>Event Emergency Code </h4>
                <p> In case QR code couldn't be read, you can use the following code (number 5) to access your event in the app. </p>
            </div>
    <br>
    <hr>


    <br>

    </div>



// WEBPACK FOOTER //
// ./src/app/core/tutorial/tutorial.component.html